var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQuoteMark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 184,
    height: 156,
    viewBox: "0 0 184 156",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.0391208 113.015C0.0391208 136.756 19.6486 156 43.8392 156C68.0302 156 87.6397 136.756 87.6397 113.015C87.6397 89.2744 68.0302 70.0303 43.8392 70.0303C38.8677 70.0303 34.1087 70.8808 29.6536 72.3797C39.5105 16.9002 83.5945 -18.8778 42.7288 10.5682C-2.58518 43.2205 -0.00941033 111.701 0.0412939 112.956C0.0412939 112.976 0.0391208 112.993 0.0391208 113.015Z",
    fill: "#6066A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.3991 113.014C96.3991 136.755 116.009 156 140.2 156C164.39 156 184 136.755 184 113.014C184 89.2739 164.39 70.0298 140.199 70.0298C135.227 70.0298 130.469 70.8803 126.014 72.3792C135.87 16.8997 179.954 -18.8783 139.089 10.5677C93.7748 43.22 96.3502 111.701 96.4013 112.956C96.4013 112.975 96.3991 112.993 96.3991 113.014Z",
    fill: "#6066A3"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuoteMark);
export default __webpack_public_path__ + "static/media/quote-mark.80c5536e13aecdeb4fca4b7d939a55ac.svg";
export { ForwardRef as ReactComponent };